import React, { useState, useEffect } from "react";
import { editSummarypromptData, editSummarylength } from "../../../services/AdminService";
import CustomeModal from "./CustomeModal";
import { toast } from "react-toastify";

const EditSummaryPrompt = ({ type, show, handleClose, item, fetchSummaryData }) => {
    const [formData, setFormData] = useState({ document_type: "", length_type: "", instruction_text: "" });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (item) {
            setFormData({
                document_type: item.document_type || "",
                length_type: item.length_type || "",
                instruction_text: item.instruction_text || ""
            });
        }
    }, [item]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleUpdate = async () => {
        if (!formData.instruction_text.trim()) {
            toast.error("Instruction text cannot be empty.");
            return;
        }

        setLoading(true);
        try {
            const payload = type === "document"
                ? { document_type: formData.document_type, instruction_text: formData.instruction_text }
                : { length_type: formData.length_type, instruction_text: formData.instruction_text };

            await (type === "document"
                ? editSummarypromptData(item.id, payload)
                : editSummarylength(item.id, payload));

            toast.success("Summary updated successfully!");
            fetchSummaryData();
            handleClose();
        } catch (error) {
            toast.error("Failed to update summary.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <CustomeModal
            type={type}
            show={show}
            handleClose={handleClose}
            title="Edit Prompt"
            onConfirm={handleUpdate}
            loading={loading}
            modalType="edit"
        >
            <label className="fw-bolder mb-1">{type === "document" ? "Document Type" : "Length Type"}</label>
            <input
                type="text"
                className="form-control mb-3"
                name={type === "document" ? "document_type" : "length_type"}
                value={type === "document" ? formData.document_type : formData.length_type}
                onChange={handleChange}
                placeholder={`Enter ${type === "document" ? "document" : "length"} type`}
            />
            <label className="fw-bolder mb-1">Prompt Instruction</label>
            <textarea
                className="form-control"
                name="instruction_text"
                value={formData.instruction_text}
                onChange={handleChange}
                placeholder="Enter instructions"
                rows={4}
                style={{ height: "180px", resize: "none" }} 
            />
        </CustomeModal>
    );
};

export default EditSummaryPrompt;
